import script from "./GuildMember.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuildMember.vue?vue&type=script&setup=true&lang=ts"

import "./GuildMember.vue?vue&type=style&index=0&id=66e8bb2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e8bb2c"]])

export default __exports__